
import {base64DecodeUnicode} from "../../../default/global/js/utilities/base64";
import {initInputBody} from "../../../reusch_global/js/inputfile";
import {initInputMaskDate} from "../../../default/global/js/inputMaskDate";
import {initPhoneCountryFields} from "../../../default/global/js/phoneCountryField";
import {focusInputGroups} from "../../../default/global/js/checkInputGroups";

function loadRecaptchaHtml(formWrapper){
    formWrapper.innerHTML = base64DecodeUnicode(formWrapper.dataset.html);
    initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate'));
    initInputBody(formWrapper.querySelectorAll('.fileBody'));
    initPhoneCountryFields(formWrapper.querySelectorAll("input[type=tel]"));
    formWrapper.querySelector("form").addEventListener("submit", function (e) {
        e.preventDefault();
        grecaptcha.execute();
    });
    focusInputGroups();
}

export function initRecaptchaForms(){
    const observer = new MutationObserver(function (mutationList,observer){
        for(let mutation of mutationList){
            let target = mutation.target;
            if(target){
                loadRecaptchaHtml(target);
            }
        }
    });

    for(let form of document.querySelectorAll('.js-RecaptchaForm')){
        if(form.dataset.html){
            // Cookie consent (DCCookie) may already have set data-html before this observer
            // attaches (e.g. returning visitors with stored consent, fast Edge reloads).
            // A MutationObserver only catches mutations after observe() runs, so decode now.
            loadRecaptchaHtml(form);
            continue;
        }
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
}